import * as React from 'react';
import {
	DateField,
	ImageField,
	NumberField,
	ReferenceField,
	ReferenceManyField,
	Show,
	ShowProps,
	Tab,
	TabbedShowLayout,
	TextField,
	UrlField
} from 'react-admin';
import { MarathonWeightingsDatagrid } from './MarathonWeightingsDatagrid';

export const MarathonShow = (props: ShowProps): React.ReactElement => {
	return (
		<Show {...props}>
			<TabbedShowLayout>
				<Tab label="DETAILS">
					<TextField source="id" label="#"/>
					<ImageField source="featuredImageUrl" label="FEATURED_IMAGE_URL"/>
					<TextField source="name" label="NAME"/>
					<TextField source="agenda" label="AGENDA"/>
					<NumberField source="duration" label="DURATION"/>
					<DateField source="date" label="DATE"/>
					<UrlField source="groupLink" label="GROUP_LINK"/>
					<ReferenceField source="coachId" reference="clients" label="COACH">
						<TextField source="fullName"/>
					</ReferenceField>

					<NumberField source="participantsIds.length" label="NUMBER_OF_PARTICIPANTS"/>
				</Tab>
				<Tab label="WEIGHTINGS" path="weightings">
					<ReferenceManyField source="id"
					                    addLabel={false}
					                    reference="weightings"
					                    target="marathon">
						<MarathonWeightingsDatagrid rootId={props.id}/>
					</ReferenceManyField>
				</Tab>
			</TabbedShowLayout>

		</Show>
	);
};
